module.exports = __webpack_public_path__ + "static/media/drawer_home_inactive.c1a50e38.svg";